import React, { useState } from 'react';
import { styleBreakMobile, styleBreakSmallMobile } from '../layouts/Globals';
import { Box, Typography, makeStyles, IconButton, Backdrop, useTheme } from '@material-ui/core';
import { ReactComponent as InfoButton } from '../../../resources/images/info.svg';
import { COLOR_GREY, COLOR_WHITE, PROGRESS_CONTAINER_COLOUR as ACTIVE_INFO_BUTTON_BACKGROUND } from '../MaterialWatchman';
import { Modal } from '@material-ui/core';
import { Fade } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    iconButton: {
        [styleBreakMobile(theme)]: {
            '&.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-colorInherit': {
                top: theme.spacing(0.25),
                padding: theme.spacing(1.25),
            },
        },
    },
    infoButton: {
        height: theme.spacing(1.875),
        width: theme.spacing(1.875),
        [styleBreakMobile(theme)]: {
            height: theme.spacing(3),
            width: theme.spacing(3),
        },
    },
    box: {
        width: theme.spacing(59.87),
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        [styleBreakMobile(theme)]: {
            maxWidth: '95%',
            width: theme.spacing(49),
        },
        [styleBreakSmallMobile(theme)]: {
            width: theme.spacing(43),
        },
        backgroundColor: COLOR_WHITE,
        borderRadius: theme.spacing(2),
    },
    typographyHead: {
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: theme.spacing(2.5),
        lineHeight: '17px',
        letterSpacing: '0.17px',
        [styleBreakMobile(theme)]: {
            margin: theme.spacing(0),
            fontSize: theme.spacing(2.5),
            lineHeight: '24px',
        },
    },
    modalBody: {
        marginTop: theme.spacing(1.9),
        marginBottom: theme.spacing(1.9),
        fontSize: theme.spacing(1.5),
        lineHeight: '14px',
        letterSpacing: '0.17px',
        [styleBreakMobile(theme)]: {
            fontStyle: 'normal',
            fontSize: theme.spacing(1.75),
            lineHeight: '21px',
        },
    },
    close: {
        cursor: 'pointer',
    },
    headControl: {
        borderBottom: `1px solid ${COLOR_GREY.light}`,
        padding: theme.spacing(1.5),
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    innerBox: {
        padding: theme.spacing(3),
        [styleBreakMobile(theme)]: {
            maxHeight: theme.spacing(43),
            overflowY: 'auto',
        },
    },
}));

export default function ModalCard({ title, infoText, dataCy }) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <IconButton
                data-cy={dataCy}
                style={open ? { background: ACTIVE_INFO_BUTTON_BACKGROUND } : { background: 'transparent' }}
                variant={open ? 'contained' : 'outlined'}
                color="inherit"
                onClick={handleOpen}
                className={classes.iconButton}
            >
                <InfoButton className={classes.infoButton} />
            </IconButton>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box className={classes.box}>
                        <Box className={classes.headControl} display="flex" justifyContent="space between">
                            <Typography variant="h2">{}</Typography>
                            <Box>
                                <Close aria-labelledby="close" fill={theme.palette.primary.dark} onClick={handleClose} className={classes.close} />
                            </Box>
                        </Box>
                        <Box className={classes.innerBox}>
                            <Typography className={classes.typographyHead}>{title}</Typography>
                            <Box className={classes.modalBody}>{infoText[title]}</Box>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
